module.exports = __webpack_public_path__ + "/login_ui/img/nf-8e3478120a13d906622d43a6cb929e8f.svg";